import timeout from './timeout';
import input from './input';
import inputMax from './inputMax';
import role from './role';
import lineSplit from './lineSplit';
import inputLimit from './inputLimit';
import tableAutoHeight from './tableAutoHeight';

export default {
  timeout,
  input,
  inputMax,
  role,
  lineSplit,
  inputLimit,
  tableAutoHeight,
};
